import React from "react";
import * as dayjs from "dayjs";
import { TruncatedCell } from "../../../common";

export const showAdminHistoryLog = (theads, tableData) => {
  return (
    <>
     <thead>
       <tr>
     {theads.map((heading, index) => {
            return <th key={index} style={{ whiteSpace: "nowrap" }}>{heading}</th>;
          })}
          </tr>

          </thead>
          <tbody>
            {tableData.map(
              ({ operationId, operationDate, operationDescription }) => {
                return (
                  <tr key={operationId}>
                    <td>{operationId}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{dayjs(operationDate).format("dddd, MMM D, YYYY h:mm A")}</td>
                    <td className="truncate-col">
                      <TruncatedCell text={operationDescription} />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
    </>
  );
};
